export const SETORES = {
  DPSE: 23,
  DFIS: 25,
  GEFIC: 26,
  COVIT: 28,
  DPLO: 29,
  MOBILE: 99997,
  INT: 99998,
  EXT: 99999,
};